// krida-ui-options.js - Options Modal handling
import { showErrorModal } from './krida-ui-error.js';

// --- Module State ---
let UIElements = null;
const optionsCallbacks = {
  onSave: null,
  onCancel: null
};

// --- Initialization ---
export function init(dependencies) {
  console.log("KridaUIOptionsModal initializing...");
  UIElements = dependencies.elements;

  if (!UIElements) {
    console.error("KridaUIOptionsModal: Missing elements dependency!");
    return;
  }
  if (!UIElements.optionsModalInputs) {
      UIElements.optionsModalInputs = {
          displayPreference: {},
          aiDifficulty: {}
      };
  }
  _createOptionsModalOnce();
  console.log("KridaUIOptionsModal initialized.");
}

function _createOptionsModalOnce() {
  UIElements.optionsModal = document.getElementById('options-modal');

  if (!UIElements.optionsModal) {
    console.log("KridaUIOptionsModal: Creating options modal structure.");
    UIElements.optionsModal = document.createElement('div');
    UIElements.optionsModal.id = 'options-modal';
    UIElements.optionsModal.className = 'modal';

    const modalContent = document.createElement('div');
    modalContent.className = 'modal-content';

    const modalHeader = document.createElement('div');
    modalHeader.className = 'modal-header';
    const title = document.createElement('div');
    title.className = 'modal-title';
    title.textContent = 'Game Options';
    modalHeader.appendChild(title);

    const modalBody = document.createElement('div');
    modalBody.className = 'modal-body';

    const darkModeDiv = document.createElement('div');
    darkModeDiv.className = 'modal-option';
    const darkModeLabel = document.createElement('label');
    UIElements.optionsModalInputs.darkMode = document.createElement('input');
    UIElements.optionsModalInputs.darkMode.type = 'checkbox';
    UIElements.optionsModalInputs.darkMode.id = 'dark-mode-option';
    darkModeLabel.appendChild(UIElements.optionsModalInputs.darkMode);
    darkModeLabel.appendChild(document.createTextNode(' Dark Mode'));
    darkModeDiv.appendChild(darkModeLabel);

    const winScoreDiv = document.createElement('div');
    winScoreDiv.className = 'modal-option';
    const winScoreLabel = document.createElement('label');
    winScoreLabel.appendChild(document.createTextNode('Winning Score: '));
    UIElements.optionsModalInputs.winningScore = document.createElement('input');
    UIElements.optionsModalInputs.winningScore.type = 'number';
    UIElements.optionsModalInputs.winningScore.id = 'winning-score-option';
    winScoreLabel.appendChild(UIElements.optionsModalInputs.winningScore);
    winScoreDiv.appendChild(winScoreLabel);

    const clearBonusDiv = document.createElement('div');
    clearBonusDiv.className = 'modal-option';
    const clearBonusLabel = document.createElement('label');
    clearBonusLabel.appendChild(document.createTextNode('Board Clear Bonus: '));
    UIElements.optionsModalInputs.bonusClearBoard = document.createElement('input');
    UIElements.optionsModalInputs.bonusClearBoard.type = 'number';
    UIElements.optionsModalInputs.bonusClearBoard.id = 'clear-bonus-option';
    clearBonusLabel.appendChild(UIElements.optionsModalInputs.bonusClearBoard);
    clearBonusDiv.appendChild(clearBonusLabel);

    const displayPrefDiv = document.createElement('div');
    displayPrefDiv.className = 'modal-option';
    const displayPrefTitle = document.createElement('div');
    displayPrefTitle.textContent = 'Stockpile Display:';
    displayPrefDiv.appendChild(displayPrefTitle);
    const baseLabel = document.createElement('label');
    UIElements.optionsModalInputs.displayPreference.base = document.createElement('input');
    UIElements.optionsModalInputs.displayPreference.base.type = 'radio';
    UIElements.optionsModalInputs.displayPreference.base.name = 'stockpileDisplay';
    UIElements.optionsModalInputs.displayPreference.base.value = 'base';
    baseLabel.appendChild(UIElements.optionsModalInputs.displayPreference.base);
    baseLabel.appendChild(document.createTextNode(' Show Base Pile'));
    displayPrefDiv.appendChild(baseLabel);
    const smallestLabel = document.createElement('label');
    UIElements.optionsModalInputs.displayPreference.smallest = document.createElement('input');
    UIElements.optionsModalInputs.displayPreference.smallest.type = 'radio';
    UIElements.optionsModalInputs.displayPreference.smallest.name = 'stockpileDisplay';
    UIElements.optionsModalInputs.displayPreference.smallest.value = 'smallest';
    smallestLabel.appendChild(UIElements.optionsModalInputs.displayPreference.smallest);
    smallestLabel.appendChild(document.createTextNode(' Show Smallest Pile'));
    displayPrefDiv.appendChild(smallestLabel);

    const buttonsDiv = document.createElement('div');
    buttonsDiv.className = 'modal-buttons';
    const saveBtn = document.createElement('button');
    saveBtn.id = 'save-options-btn';
    saveBtn.textContent = 'Save';
    saveBtn.addEventListener('click', saveOptions);
    const cancelBtn = document.createElement('button');
    cancelBtn.id = 'cancel-options-btn';
    cancelBtn.textContent = 'Cancel';
    cancelBtn.addEventListener('click', closeOptionsModal);
    buttonsDiv.appendChild(saveBtn);
    buttonsDiv.appendChild(cancelBtn);

    modalBody.appendChild(darkModeDiv);
    modalBody.appendChild(winScoreDiv);
    modalBody.appendChild(clearBonusDiv);
    modalBody.appendChild(displayPrefDiv);
    modalContent.appendChild(modalHeader);
    modalContent.appendChild(modalBody);
    modalContent.appendChild(buttonsDiv);
    UIElements.optionsModal.appendChild(modalContent);
    document.body.appendChild(UIElements.optionsModal);
  } else {
    console.log("KridaUIOptionsModal: Options modal structure already exists (static HTML).");
    if (!UIElements.optionsModalInputs.winningScore) {
      UIElements.optionsModalInputs.winningScore = document.getElementById('winning-score-option');
      UIElements.optionsModalInputs.darkMode = document.getElementById('dark-mode-option');
      UIElements.optionsModalInputs.bonusClearBoard = document.getElementById('clear-bonus-option');
      if (!UIElements.optionsModalInputs.displayPreference) {
         UIElements.optionsModalInputs.displayPreference = {};
      }
      UIElements.optionsModalInputs.displayPreference.base = document.getElementById('display-base');
      UIElements.optionsModalInputs.displayPreference.smallest = document.getElementById('display-smallest');
      
      if (!UIElements.optionsModalInputs.aiDifficulty) {
          UIElements.optionsModalInputs.aiDifficulty = {};
      }

      UIElements.optionsModalInputs.aiDifficulty.easy = document.getElementById('ai-easy');
      UIElements.optionsModalInputs.aiDifficulty.medium = document.getElementById('ai-medium');
    }
    const saveBtn = document.getElementById('save-options-btn');
    const cancelBtn = document.getElementById('cancel-options-btn');
    if (saveBtn && !saveBtn.onclick) { saveBtn.addEventListener('click', saveOptions); }
    if (cancelBtn && !cancelBtn.onclick) { cancelBtn.addEventListener('click', closeOptionsModal); }
  }
  UIElements.optionsModal.style.display = 'none';
}

export function openOptionsModal(options, saveCallback) {
  if (!UIElements || !UIElements.optionsModal) {
    console.error("KridaUIOptionsModal Error: Modal elements not initialized!");
    showErrorModal("UI Error", "Options modal is not available.");
    return;
  }

  // Task 4.3: Show locked message for tournament games
  if (options && options.optionsLocked) {
    _showLockedOptionsModal();
    return;
  }

  const inputs = UIElements.optionsModalInputs;
  if (options) {
    if (inputs.darkMode) inputs.darkMode.checked = options.darkMode || false;
    if (inputs.winningScore) inputs.winningScore.value = options.winningScore || 150;
    if (inputs.bonusClearBoard) inputs.bonusClearBoard.value = options.bonusClearBoard === undefined ? 25 : options.bonusClearBoard;
    const currentPref = options.stockpileDisplayPreference || 'base';
    if (inputs.displayPreference.base) inputs.displayPreference.base.checked = (currentPref === 'base');
    if (inputs.displayPreference.smallest) inputs.displayPreference.smallest.checked = (currentPref === 'smallest');

    const currentAIDifficulty = options.aiDifficulty || 'easy';
    if (inputs.aiDifficulty.easy) inputs.aiDifficulty.easy.checked = (currentAIDifficulty === 'easy');
    if (inputs.aiDifficulty.medium) inputs.aiDifficulty.medium.checked = (currentAIDifficulty === 'medium');
  }
  optionsCallbacks.onSave = (typeof saveCallback === 'function') ? saveCallback : null;
  UIElements.optionsModal.style.display = 'block';
}

function _showLockedOptionsModal() {
  const modal = UIElements.optionsModal;
  const content = modal.querySelector('.modal-content');
  if (!content) { modal.style.display = 'block'; return; }

  const buttons = content.querySelector('.modal-buttons');
  const saveBtn = buttons ? buttons.querySelector('#save-options-btn') : null;

  // Hide all option elements (works whether .modal-body exists or not)
  const optionElements = content.querySelectorAll('.modal-option, .modal-body, div:not(.modal-title):not(.modal-buttons)');
  const hiddenEls = [];
  optionElements.forEach(el => {
    if (el !== buttons && !el.classList.contains('modal-title') && !el.classList.contains('modal-buttons') && !el.closest('.modal-buttons')) {
      el.dataset.lockedHidden = el.style.display;
      el.style.display = 'none';
      hiddenEls.push(el);
    }
  });

  // Insert locked message
  const lockedMsg = document.createElement('p');
  lockedMsg.className = 'options-locked-message';
  lockedMsg.textContent = 'Tournament settings — cannot be changed';
  if (buttons) {
    content.insertBefore(lockedMsg, buttons);
  } else {
    content.appendChild(lockedMsg);
  }

  if (saveBtn) saveBtn.style.display = 'none';
  modal.style.display = 'block';

  // Restore on close
  const restoreHandler = () => {
    hiddenEls.forEach(el => {
      el.style.display = el.dataset.lockedHidden || '';
      delete el.dataset.lockedHidden;
    });
    lockedMsg.remove();
    if (saveBtn) saveBtn.style.display = '';
  };
  const cancelBtn = buttons ? buttons.querySelector('#cancel-options-btn') : null;
  if (cancelBtn) {
    const wrappedClose = () => {
      restoreHandler();
      closeOptionsModal();
      cancelBtn.removeEventListener('click', wrappedClose);
    };
    cancelBtn.addEventListener('click', wrappedClose);
  }
}

export function closeOptionsModal() {
  if (UIElements && UIElements.optionsModal) {
    UIElements.optionsModal.style.display = 'none';
    optionsCallbacks.onSave = null;
  } else {
    console.error("KridaUIOptionsModal: Options modal element not found for closing.");
  }
}

function saveOptions() {
  if (!UIElements || !UIElements.optionsModalInputs || !UIElements.optionsModalInputs.winningScore || !UIElements.optionsModalInputs.darkMode) {
    console.error("KridaUIOptionsModal Error: Cannot save options, input elements not cached/found.");
    closeOptionsModal();
    return;
  }
  const inputs = UIElements.optionsModalInputs;
  const winningScore = parseInt(inputs.winningScore.value, 10) || 150;
  const bonusClearBoard = inputs.bonusClearBoard ? (parseInt(inputs.bonusClearBoard.value, 10) === undefined ? 25 : parseInt(inputs.bonusClearBoard.value, 10)) : 25;
  const darkMode = inputs.darkMode.checked;
  let stockpileDisplayPreference = 'base';
  if (inputs.displayPreference.smallest && inputs.displayPreference.smallest.checked) {
    stockpileDisplayPreference = 'smallest';
  }

  let aiDifficulty = 'easy';
  if (inputs.aiDifficulty.medium && inputs.aiDifficulty.medium.checked) {
      aiDifficulty = 'medium';
  }

  const savedOptions = { 
      winningScore, 
      darkMode, 
      stockpileDisplayPreference, 
      bonusClearBoard, 
      aiDifficulty
  };
  console.log("KridaUIOptionsModal: Saving options:", savedOptions);
  if (optionsCallbacks.onSave) {
    optionsCallbacks.onSave(savedOptions);
  } else {
    console.warn("KridaUIOptionsModal: No save callback registered.");
  }
  closeOptionsModal();
} 